export default __webpack_public_path__ + "e2d7160ffaf373b0a3f7cf33347707b2.png";